import React, { Component } from 'react'
import ReactGA from 'react-ga'

class Analytics extends Component {

	componentDidMount() {
        ReactGA.initialize(process.env.REACT_APP_GA_ID)
        ReactGA.pageview(window.location.pathname + window.location.search)
	}

	render() {
		return <div></div>
	}
}

export { Analytics }